export class Time {
	hour?: number;
	minute?: number;

	get currentTime(): string {
		return this.hour != undefined && this.minute != undefined ? (this.hour < 10 ? '0' : '') + this.hour + ':' + (this.minute < 10 ? '0' : '') + this.minute : '';
	}
}